import React, { Component } from 'react';
import { ButtonToolbar, FormGroup, ControlLabel, FormControl} from 'react-bootstrap';
import ToggleButtonGroup from 'react-bootstrap/lib/ToggleButtonGroup'
import ToggleButton from 'react-bootstrap/lib/ToggleButton'


class PrettyPrintIO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputFormat: 'json',
      inputValue: '{ "MyStringArray" : ["somestring1", "somestring2"] }',
      outputValue: '',
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    // this.setState({inputValue: event.target.value});
    let outputValue = this.isValidString(event.target.value) === true ? this.getOutputValue(event.target.value) : 'Invalid JSON String';
    this.setState({...this.state, outputValue: outputValue})
  }

  isValidString(str) {
    let result = true;
    try {
      if(str !== '') {
        JSON.parse(str);
      }
    } catch (e) {
      result = false;
    }
    return result;
  }

  getOutputValue(inputValue, count=1, breakIsTrue=false, openingIsTrue=false) {
    // return inputValue.replace(/{{1}(.*$)/g, ()=>) // I like thi ides of capturing everything else here and passing it in, but goign to see if i can use the replace() methods
    let tmp = '';
    for (let i = 0, len = inputValue.length; i < len; i++) {
      let matchOpen = inputValue[i].match(/{|\[/);
      let matchClose = inputValue[i].match(/}|\]/);
      let matchBreak = inputValue[i].match(/,/);
      let matchUnwantedChars = inputValue[i].match(/(\r|\n|\r\n|\n\r)/);
      let indent = '';
      for( let ii = 0; ii < count; ii++) {
        indent = indent + '\t'
      }
      if(matchOpen !== null) {
        return tmp + inputValue[i] + "\r\n" + indent + this.getOutputValue(inputValue.substring(i+1), count+1, false, true);
      } else if (matchClose !== null) {
        indent = indent.substring(0, indent.length - 2);
        return tmp + "\r\n" + indent + inputValue[i] + this.getOutputValue(inputValue.substring(i+1), count-1);
      } else if (matchBreak !== null) {
        indent = indent.substring(0, indent.length - 1);
        return tmp + inputValue[i] + "\r\n" + indent + this.getOutputValue(inputValue.substring(i+1), count, true);
      } else {
        if((openingIsTrue == true || breakIsTrue == true) && inputValue[i] === ' ') {
          continue;
        }
        if(matchUnwantedChars !== null) {
          continue;
        }
        tmp = tmp + inputValue[i];
      }
    }
    return tmp;
  }

  render() {
    return (
      <div>
        {/* <input type="text" value= {this.state.inputValue}></input> */}
        {this.props.children}
        <FormGroup controlId="formControlsTextarea" className="top-buffer">
          <ControlLabel>Input</ControlLabel>
          <ButtonToolbar>
            <ToggleButtonGroup onChange={this.handleInputFormatChange} name="input_format" type="radio" defaultValue={this.state.inputFormat} >
              <ToggleButton value={'json'}>JSON</ToggleButton>
            </ToggleButtonGroup>
          </ButtonToolbar>
          <FormControl className="top-buffer" onChange={this.handleInputChange} componentClass="textarea" placeholder="Pretty Print Input" />
        </FormGroup>

        <FormGroup controlId="formControlsTextarea" className="top-buffer">
          <ControlLabel>Output</ControlLabel>
          <pre><code className="javascript">{this.state.outputValue}</code></pre>
        </FormGroup>
      </div>
    );
  }
}

export default PrettyPrintIO;



// WEBPACK FOOTER //
// ./src/components/PrettyPrintIO/PrettyPrintIO.js